import moment from 'moment'
import { intervalToString } from './interval-to-string'

/**
 * Helper function to convert an interval object with inclusive bounds to an interval
 * string with exclusive upper bound that will be processed correctly by backend request via REST.
 * (REST endpoint parameter, e.g. 'endTime-interval', will exclude the end date.)
 * The dates are converted to UTC and formatted to standard ISO-8601 ('YYYY-MM-DDTHH:mm:ss.SSSZ').
 * Example interval: '2020-09-08T12:34:56.123Z/2020-09-08T23:45:43.000Z
 *
 * @param {object} interval - An interval object that includes start and end datetime.
 * @param {moment.Moment|number|string|Date} interval.start - The start datetime of the interval.
 * @param {moment.Moment|number|string|Date} interval.end - The end datetime of the interval.
 * @returns {string|null} - An ISO8601-formatted interval string.
 */

export const exclusiveUpperBoundUtcIntervalString = ({ end, start }) => {
    let newStart, newEnd

    if (typeof start === 'string' || typeof start === 'number') {
        newStart = new Date(start)
    } else if (start instanceof Date) {
        newStart = start
    } else if (start instanceof moment) {
        newStart = start.toDate()
    }

    if (typeof end === 'number') {
        newEnd = new Date(end + 1)
    } else if (typeof end === 'string') {
        newEnd = new Date(new Date(end).getTime() + 1)
    } else if (end instanceof Date) {
        newEnd = new Date(end.getTime() + 1)
    } else if (end instanceof moment) {
        newEnd = moment(end).add(1, 'ms').toDate()
    }

    if (!start || !end) {
        return null
    }

    return intervalToString({
        end: newEnd,
        start: newStart
    })
}
